export default __webpack_public_path__ + "static/media/ImageThree.fce3bce0.jpg";